(function (window, $) {
    window.onload = function () {
        if ($('.notification-dismiss-selector').length > 0) {
            setTimeout(dismissAlert, 3000);
        }

        /**
         * Remove alertbox
         *
         * @return undefined
         */
        function dismissAlert() {
            var alerts = $('.notification-dismiss-selector');

            $.each(alerts, function (i, alert) {
                $(alert).fadeOut(500, 'swing', function () {
                    alert.remove();
                });
            })
        }
    }
})(window, jQuery);
